<template>
  <van-image
    round
    fit="cover"
    :width="size"
    :height="size"
    :icon-size="size"
    :src="src"
    :name="name"
    class="avatar-box"
  >
    <template #loading>
      <div v-if="showName && firstLetter" class="letter" :style="nameStyle">
        {{ firstLetter }}
      </div>
      <van-icon v-else name="user-circle-o" class="icon" :style="iconStyle" />
    </template>
    <template #error>
      <div v-if="showName && firstLetter" class="letter" :style="nameStyle">
        {{ firstLetter }}
      </div>
      <van-icon v-else name="user-circle-o" class="icon" :style="iconStyle" />
    </template>
  </van-image>
</template>

<script>
import { reactive } from 'vue';
import { computed } from '@vue/runtime-core';
export default {
  name: 'avatar',
  props: {
    size: {
      type: Number,
      required: true,
    },
    src: {
      required: true,
    },
    name: {},
    //没有头像时展示名称
    showName: {
      default: true,
    },
  },
  setup(props) {
    const firstLetter = computed(() => {
      let name = (props.name || '').replace(/\(|\)|（|）/g, '');
      return name[0];
    });

    const iconStyle = computed(() => {
      return {
        fontSize: props.size + 'px',
      };
    });

    const nameStyle = computed(() => {
      let size = Math.floor((props.size / 3) * 2);
      if (size < 12) {
        size = 12;
      }
      return {
        fontSize: size + 'px',
      };
    });

    return {
      firstLetter,
      iconStyle,
      nameStyle,
      // size: props.size,
      // src: props.src,
    };
  },
};
</script>

<style scoped lang="less">
.avatar-box {
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
}
</style>
